/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {BaseLoginProvider as ɵa} from './src/entities/base-login-provider';